import axios from 'axios'
import { ADMIN_API_URL } from 'const'

const BASE_URL = `${ADMIN_API_URL}/reclips`

export const getReclip = async (sourceId) => {
  try {
    const { data: reclip } = await axios.get(`${BASE_URL}/${sourceId}`)
    return reclip
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const getReclipAudio = async (sourceId, trim = true) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/${sourceId}/audio`, {
      params: { trim },
      responseType: 'blob',
    })
    return data
  } catch (err) {
    if (err.response?.data instanceof Blob) {
      const errorText = await err.response.data.text()
      try {
        const errorJson = JSON.parse(errorText)
        throw new Error(errorJson.detail || err.message)
      } catch (e) {
        throw new Error(errorText || err.message)
      }
    }
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const editReclip = async (shareCode, editorUserId) => {
  try {
    const { data: audio } = await axios.post(`${BASE_URL}/edit_from_share`, {
      share_code: shareCode,
      editor_user_id: editorUserId,
    })
    return audio
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const uploadCoverPhoto = async ({ sourceId, formData }) => {
  try {
    const url = `${ADMIN_API_URL}/cover_photos/update/by_source_id/${sourceId}`
    const { data } = await axios.put(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return data
  } catch (err) {
    console.log('throwing', err)
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const uploadCoverPhotoByShareCode = async ({ shareCode, formData }) => {
  try {
    const url = `${ADMIN_API_URL}/cover_photos/update/by_share_code/${shareCode}`
    const { data } = await axios.put(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return data
  } catch (err) {
    console.log('throwing', err)
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const deleteCoverVideoByShareCode = async (shareCode) => {
  try {
    const url = `${ADMIN_API_URL}/cover_photos/delete_cover_video/by_share_code/${shareCode}`
    const { data } = await axios.delete(url)
    return data
  } catch (err) {
    console.log('throwing', err)
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const copyReclipByShareCode = async ({ shareCode, toUsername }) => {
  try {
    const url = `${BASE_URL}/copy_within_env_by_share_code`
    const { data } = await axios.post(url, {
      share_code: shareCode,
      to_username: toUsername,
    })
    return data
  } catch (err) {
    console.log('throwing', err)
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const getRandomSourceIds = async (
  count = 10,
  minDuration = 15,
  minWords = 7,
  myClipsOnly = false,
  captureMode = null
) => {
  try {
    const params = {
      count,
      min_duration: minDuration,
      min_words: minWords,
      my_clips_only: myClipsOnly,
    }
    if (captureMode) params.capture_mode = captureMode
    const { data } = await axios.get(`${BASE_URL}/random`, { params })
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}

export const getReclipRawTranscript = async (sourceId, trim = true) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/${sourceId}/raw_transcript`, {
      params: { trim },
    })
    return data
  } catch (err) {
    throw new Error(err.response?.data?.detail || err.message)
  }
}
